import { TShipmentManagement } from '@features/shipment/registration/state_management/types'
import axios from '@utils/axios-client'

class MeshAPI {
    prefix = '/api/v1/Mesh';
    prefixLocation = '/api/v1/Location'

    async fetchList() {
        const url = `${this.prefix}/GetAll`;
        const response = await axios.get(url)
        return response.data;
    }

    async siteUpdate(params: any) {
        const url = `${this.prefix}/SiteUpdate`
        return await axios.put(url, params)
    }

    async resetBeforePumping(params: any) {
        const url = `${this.prefix}/resetBeforePumping`
        return await axios.put(url, params)
    }

    async siteUpdateList(params: any) {
        const url = `${this.prefix}/SiteUpdateList`
        return await axios.put(url, params)
    }

    async revertByPump(pumpId: string) {
        const url = `${this.prefix}/RevertByPump?pumpId=${pumpId}`
        return await axios.put(url)
    }

    async locationUpdateStatus(params: any) {
        const url = `${this.prefixLocation}/UpdateStatus`
        return await axios.put(url, params)
    }

    async fetchUnderMesh() {
        const url = `${this.prefix}/GetUnderMesh`;
        const response = await axios.get(url)
        return response.data;
    }

    // #8426 (2D): FE scans PNG then registers the mesh grid. BE stores it (does not scan images).
    // Color convention per cell: R = marker, G = pumpNumber (ポンプ車番号), B = row (メッシュ番号); layer from filename.
    // BE: MeshController.CreateBatch2D -> MeshCreateBatch2DRequest.
    async createBatch2D(payload: IMeshCreateBatch2D) {
        const url = `${this.prefix}/CreateBatch2D`
        return await axios.post(url, payload)
    }
}

export interface IMeshCell2D {
    layer: number;
    row: number;            // B channel = メッシュ番号
    pumpNumber?: number | null; // G channel = ポンプ車番号; 0/null = no pump
    code?: string;
    pumpId?: string | null;
}
export interface IUnderRelation2D {
    layer: number;
    row: number;
    underLayer: number;
    underRow: number;
}
export interface IMeshCreateBatch2D {
    locationId: string;
    replaceExisting: boolean;
    cells: IMeshCell2D[];
    underRelations: IUnderRelation2D[];
}

export const meshAPI = new MeshAPI()